import { createAction } from 'redux-actions';

export const getInvestmentHoldings = createAction('GET_INVESTMENT_HOLDINGS');
export const getInvestmentHoldingsSuccess = createAction('GET_INVESTMENT_HOLDINGS_SUCCESS');
export const getInvestmentHoldingsFailure = createAction('GET_INVESTMENT_HOLDINGS_FAILURE');
